// source: task.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
var google_type_money_pb = require('./google/type/money_pb.js');
goog.object.extend(proto, google_type_money_pb);
var cost_analysis_pb = require('./cost_analysis_pb.js');
goog.object.extend(proto, cost_analysis_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PageIngestionMode', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ProgressStep', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.ProgressStep.StepStatus', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.Task', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.TaskUpdate', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.stepProgressPercent', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.stepTitle', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.Task = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.Task.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.Task, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.Task.displayName = 'proto.org.codetricks.construction.code.assistant.service.Task';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.TaskUpdate.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.TaskUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.TaskUpdate.displayName = 'proto.org.codetricks.construction.code.assistant.service.TaskUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.ProgressStep, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.ProgressStep.displayName = 'proto.org.codetricks.construction.code.assistant.service.ProgressStep';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.displayName = 'proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.Task.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.Task.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.Task} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.Task.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
taskType: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
progress: jspb.Message.getFieldWithDefault(msg, 4, 0),
message: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 8, ""),
completedAt: jspb.Message.getFieldWithDefault(msg, 9, ""),
failedAt: jspb.Message.getFieldWithDefault(msg, 10, ""),
cancelledAt: jspb.Message.getFieldWithDefault(msg, 16, ""),
requestMetadata: jspb.Message.getFieldWithDefault(msg, 11, ""),
resultMap: (f = msg.getResultMap()) ? f.toObject(includeInstance, undefined) : [],
currentStep: jspb.Message.getFieldWithDefault(msg, 13, 0),
progressStepsList: jspb.Message.toObjectList(msg.getProgressStepsList(),
    proto.org.codetricks.construction.code.assistant.service.ProgressStep.toObject, includeInstance),
projectId: jspb.Message.getFieldWithDefault(msg, 15, ""),
costAnalysis: (f = msg.getCostAnalysis()) && cost_analysis_pb.MetaCostAnalysis.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task}
 */
proto.org.codetricks.construction.code.assistant.service.Task.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.Task;
  return proto.org.codetricks.construction.code.assistant.service.Task.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.Task} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task}
 */
proto.org.codetricks.construction.code.assistant.service.Task.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskType(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProgress(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailedAt(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCancelledAt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestMetadata(value);
      break;
    case 12:
      var value = msg.getResultMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 13:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} */ (reader.readEnum());
      msg.setCurrentStep(value);
      break;
    case 14:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProgressStep;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProgressStep.deserializeBinaryFromReader);
      msg.addProgressSteps(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 17:
      var value = new cost_analysis_pb.MetaCostAnalysis;
      reader.readMessage(value,cost_analysis_pb.MetaCostAnalysis.deserializeBinaryFromReader);
      msg.setCostAnalysis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.Task.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.Task} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.Task.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getProgress();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCompletedAt();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFailedAt();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCancelledAt();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRequestMetadata();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getResultMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(12, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCurrentStep();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getProgressStepsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProgressStep.serializeBinaryToWriter
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCostAnalysis();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      cost_analysis_pb.MetaCostAnalysis.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus = {
  PENDING: 0,
  PROCESSING: 1,
  COMPLETE: 2,
  FAILED: 3,
  CANCELLED: 4
};

/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_type = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getTaskType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TaskStatus status = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 progress = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getProgress = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setProgress = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string message = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string created_by = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string created_at = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string updated_at = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string completed_at = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getCompletedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setCompletedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string failed_at = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getFailedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setFailedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string cancelled_at = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getCancelledAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setCancelledAt = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string request_metadata = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getRequestMetadata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setRequestMetadata = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * map<string, string> result = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getResultMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.clearResultMap = function() {
  this.getResultMap().clear();
  return this;
};


/**
 * optional PlanIngestionStep current_step = 13;
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getCurrentStep = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setCurrentStep = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * repeated ProgressStep progress_steps = 14;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.ProgressStep>}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getProgressStepsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.ProgressStep>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProgressStep, 14));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.ProgressStep>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
*/
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setProgressStepsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProgressStep=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.addProgressSteps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.org.codetricks.construction.code.assistant.service.ProgressStep, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.clearProgressStepsList = function() {
  return this.setProgressStepsList([]);
};


/**
 * optional string project_id = 15;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional cost.MetaCostAnalysis cost_analysis = 17;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.getCostAnalysis = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} */ (
    jspb.Message.getWrapperField(this, cost_analysis_pb.MetaCostAnalysis, 17));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
*/
proto.org.codetricks.construction.code.assistant.service.Task.prototype.setCostAnalysis = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task} returns this
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.clearCostAnalysis = function() {
  return this.setCostAnalysis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.Task.prototype.hasCostAnalysis = function() {
  return jspb.Message.getField(this, 17) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.TaskUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 1, 0),
progress: jspb.Message.getFieldWithDefault(msg, 2, 0),
message: jspb.Message.getFieldWithDefault(msg, 3, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 4, ""),
completedAt: jspb.Message.getFieldWithDefault(msg, 5, ""),
failedAt: jspb.Message.getFieldWithDefault(msg, 6, ""),
cancelledAt: jspb.Message.getFieldWithDefault(msg, 10, ""),
resultMap: (f = msg.getResultMap()) ? f.toObject(includeInstance, undefined) : [],
progressStepsList: jspb.Message.toObjectList(msg.getProgressStepsList(),
    proto.org.codetricks.construction.code.assistant.service.ProgressStep.toObject, includeInstance),
currentStep: jspb.Message.getFieldWithDefault(msg, 9, 0),
costAnalysis: (f = msg.getCostAnalysis()) && cost_analysis_pb.MetaCostAnalysis.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.TaskUpdate;
  return proto.org.codetricks.construction.code.assistant.service.TaskUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProgress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCancelledAt(value);
      break;
    case 7:
      var value = msg.getResultMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = new proto.org.codetricks.construction.code.assistant.service.ProgressStep;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.ProgressStep.deserializeBinaryFromReader);
      msg.addProgressSteps(value);
      break;
    case 9:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} */ (reader.readEnum());
      msg.setCurrentStep(value);
      break;
    case 11:
      var value = new cost_analysis_pb.MetaCostAnalysis;
      reader.readMessage(value,cost_analysis_pb.MetaCostAnalysis.deserializeBinaryFromReader);
      msg.setCostAnalysis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.TaskUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProgress();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCompletedAt();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFailedAt();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCancelledAt();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getResultMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getProgressStepsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.org.codetricks.construction.code.assistant.service.ProgressStep.serializeBinaryToWriter
    );
  }
  f = message.getCurrentStep();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getCostAnalysis();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      cost_analysis_pb.MetaCostAnalysis.serializeBinaryToWriter
    );
  }
};


/**
 * optional Task.TaskStatus status = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.Task.TaskStatus} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 progress = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getProgress = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setProgress = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updated_at = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string completed_at = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getCompletedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setCompletedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string failed_at = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getFailedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setFailedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string cancelled_at = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getCancelledAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setCancelledAt = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * map<string, string> result = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getResultMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.clearResultMap = function() {
  this.getResultMap().clear();
  return this;
};


/**
 * repeated ProgressStep progress_steps = 8;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.ProgressStep>}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getProgressStepsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.ProgressStep>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.ProgressStep, 8));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.ProgressStep>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
*/
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setProgressStepsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProgressStep=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.addProgressSteps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.org.codetricks.construction.code.assistant.service.ProgressStep, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.clearProgressStepsList = function() {
  return this.setProgressStepsList([]);
};


/**
 * optional PlanIngestionStep current_step = 9;
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getCurrentStep = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setCurrentStep = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional cost.MetaCostAnalysis cost_analysis = 11;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.getCostAnalysis = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} */ (
    jspb.Message.getWrapperField(this, cost_analysis_pb.MetaCostAnalysis, 11));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
*/
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.setCostAnalysis = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.TaskUpdate} returns this
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.clearCostAnalysis = function() {
  return this.setCostAnalysis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.TaskUpdate.prototype.hasCostAnalysis = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.ProgressStep.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.toObject = function(includeInstance, msg) {
  var f, obj = {
step: jspb.Message.getFieldWithDefault(msg, 1, 0),
stepName: jspb.Message.getFieldWithDefault(msg, 16, ""),
stepType: jspb.Message.getFieldWithDefault(msg, 17, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
completedAt: jspb.Message.getFieldWithDefault(msg, 4, ""),
durationMs: jspb.Message.getFieldWithDefault(msg, 5, 0),
details: jspb.Message.getFieldWithDefault(msg, 6, ""),
startedAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
stepNumber: jspb.Message.getFieldWithDefault(msg, 8, 0),
totalSteps: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.ProgressStep;
  return proto.org.codetricks.construction.code.assistant.service.ProgressStep.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} */ (reader.readEnum());
      msg.setStep(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStepName(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setStepType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.ProgressStep.StepStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDurationMs(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetails(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStepNumber(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalSteps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.ProgressStep.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStep();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStepName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getStepType();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCompletedAt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDurationMs();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getDetails();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStartedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStepNumber();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTotalSteps();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.StepStatus = {
  PENDING: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  FAILED: 3,
  SKIPPED: 4
};

/**
 * optional PlanIngestionStep step = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getStep = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setStep = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string step_name = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getStepName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setStepName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string step_type = 17;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getStepType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setStepType = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional StepStatus status = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep.StepStatus}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.ProgressStep.StepStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.ProgressStep.StepStatus} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string completed_at = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getCompletedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setCompletedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 duration_ms = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getDurationMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setDurationMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string details = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string started_at = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getStartedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setStartedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 step_number = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getStepNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setStepNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 total_steps = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.getTotalSteps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.ProgressStep} returns this
 */
proto.org.codetricks.construction.code.assistant.service.ProgressStep.prototype.setTotalSteps = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusRequest.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
task: (f = msg.getTask()) && proto.org.codetricks.construction.code.assistant.service.Task.toObject(includeInstance, f),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.Task;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.Task.deserializeBinaryFromReader);
      msg.setTask(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTask();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.Task.serializeBinaryToWriter
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional Task task = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.Task}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.prototype.getTask = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.Task} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.Task, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.Task|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.prototype.setTask = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.prototype.clearTask = function() {
  return this.setTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.prototype.hasTask = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetTaskStatusResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
operationId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest;
  return proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string operation_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.prototype.getOperationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeRequest.prototype.setOperationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
operationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
holdAmount: (f = msg.getHoldAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
dailyCommitmentAfter: (f = msg.getDailyCommitmentAfter()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse;
  return proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperationId(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setHoldAmount(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setDailyCommitmentAfter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOperationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHoldAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getDailyCommitmentAfter();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string operation_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.getOperationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.setOperationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Money hold_amount = 3;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.getHoldAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.setHoldAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.clearHoldAmount = function() {
  return this.setHoldAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.hasHoldAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Money daily_commitment_after = 4;
 * @return {?proto.google.type.Money}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.getDailyCommitmentAfter = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.setDailyCommitmentAfter = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.clearDailyCommitmentAfter = function() {
  return this.setDailyCommitmentAfter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.StartBillingHoldLifecycleProbeResponse.prototype.hasDailyCommitmentAfter = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest;
  return proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeRequest.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
released: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse;
  return proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReleased(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReleased();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool released = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.prototype.getReleased = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.CancelBillingHoldLifecycleProbeResponse.prototype.setReleased = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
enableOrientationDetection: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
generateExplanation: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
mode: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions}
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions;
  return proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions}
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableOrientationDetection(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGenerateExplanation(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.service.PageIngestionMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnableOrientationDetection();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getGenerateExplanation();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional bool enable_orientation_detection = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.prototype.getEnableOrientationDetection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.prototype.setEnableOrientationDetection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool generate_explanation = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.prototype.getGenerateExplanation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.prototype.setGenerateExplanation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional PageIngestionMode mode = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageIngestionMode}
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.prototype.getMode = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.service.PageIngestionMode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.PageIngestionMode} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions} returns this
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
forceReprocess: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
options: (f = msg.getOptions()) && proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.toObject(includeInstance, f),
billingOperationId: jspb.Message.getFieldWithDefault(msg, 6, ""),
billingOperationTaskCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
billingOperationChildKey: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest;
  return proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForceReprocess(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.deserializeBinaryFromReader);
      msg.setOptions(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingOperationId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBillingOperationTaskCount(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingOperationChildKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getForceReprocess();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOptions();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions.serializeBinaryToWriter
    );
  }
  f = message.getBillingOperationId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBillingOperationTaskCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getBillingOperationChildKey();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool force_reprocess = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.getForceReprocess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.setForceReprocess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional PageIngestionOptions options = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.getOptions = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.PageIngestionOptions|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.setOptions = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.clearOptions = function() {
  return this.setOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.hasOptions = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string billing_operation_id = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.getBillingOperationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.setBillingOperationId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 billing_operation_task_count = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.getBillingOperationTaskCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.setBillingOperationTaskCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string billing_operation_child_key = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.getBillingOperationChildKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileRequest.prototype.setBillingOperationChildKey = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
filename: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
success: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
message: jspb.Message.getFieldWithDefault(msg, 6, ""),
completedAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse;
  return proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCompletedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string filename = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_number = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool success = 5;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string message = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string completed_at = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.getCompletedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.setCompletedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string file_id = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.StartAsyncIngestFileResponse.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.PlanIngestionStep = {
  UNKNOWN_STEP: 0,
  SERVER_WARMUP: 1,
  INITIALIZE_INGESTION: 2,
  VALIDATE_METADATA: 3,
  INITIALIZE_REVIEWER: 4,
  PREPARE_PROCESSING: 5,
  LOAD_PDF_DOCUMENT: 6,
  EXTRACT_PAGE: 7,
  DETECT_ORIENTATION: 8,
  EXTRACT_TEXT_CONTENT: 9,
  SUMMARIZE_CONTENT: 10,
  PROCESS_ELEMENTS: 11,
  GENERATE_EXPLANATION: 12,
  FINALIZE_RESULTS: 13,
  INGESTION_COMPLETE: 14
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.PageIngestionMode = {
  PAGE_INGESTION_MODE_UNSPECIFIED: 0,
  PAGE_INGESTION_MODE_REGION_HIERARCHY: 1,
  PAGE_INGESTION_MODE_REVERT_REGION_HIERARCHY: 2
};


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `stepTitle`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.org.codetricks.construction.code.assistant.service.stepTitle = new jspb.ExtensionFieldInfo(
    50001,
    {stepTitle: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.EnumValueOptions.extensionsBinary[50001] = new jspb.ExtensionFieldBinaryInfo(
    proto.org.codetricks.construction.code.assistant.service.stepTitle,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.EnumValueOptions.extensions[50001] = proto.org.codetricks.construction.code.assistant.service.stepTitle;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `stepProgressPercent`.
 * @type {!jspb.ExtensionFieldInfo<number>}
 */
proto.org.codetricks.construction.code.assistant.service.stepProgressPercent = new jspb.ExtensionFieldInfo(
    50002,
    {stepProgressPercent: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.EnumValueOptions.extensionsBinary[50002] = new jspb.ExtensionFieldBinaryInfo(
    proto.org.codetricks.construction.code.assistant.service.stepProgressPercent,
    jspb.BinaryReader.prototype.readInt32,
    jspb.BinaryWriter.prototype.writeInt32,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.EnumValueOptions.extensions[50002] = proto.org.codetricks.construction.code.assistant.service.stepProgressPercent;

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.service);
